import module from 'finanzas/module.js'

const schema = {
  Fecha: 'date',
  Importe: 'number',
  Captura_Fecha: 'timestamp',
  Servicios: 'array',
}

function FinanzasGastosVsBancosProvider ($api, $schema) {
  var FinanzasGastosVsBancos = {}

  FinanzasGastosVsBancos.$get = function (folio) {
    return $api.post('kendu/finanzas/gastosVsBancos/get', {
        folio: folio,
      })
      .then((reference) => format(reference))
  }

  FinanzasGastosVsBancos.$add = function (folio, reference) {
    return $api.post('kendu/finanzas/gastosVsBancos/add', {
        folio: folio,
        reference: format(reference, true),
      })
      .then((reference) => format(reference))
  }

  FinanzasGastosVsBancos.$getService = function (folio) {
    return $api.post('kendu/finanzas/gastosVsBancos/get_service', {
        folio: folio.pad(10),
      })
      .then((service) => {
        return service ? $schema(service, {
          Importe: 'number',
          Fecha_Movimiento: 'date',
        }) : service
      })
  }

  FinanzasGastosVsBancos.$select = function (date) {
    return $api.post('kendu/finanzas/gastosVsBancos/select', {
      date: date.toYMD(),
    })
  }

  function format (data, encode) {
    return $schema(data, schema, encode)
  }

  return FinanzasGastosVsBancos
}

module.factory('FinanzasGastosVsBancos', FinanzasGastosVsBancosProvider)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasGastosVsBancos.js